var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9C9.73175 9 11.75 6.98175 11.75 4.5C11.75 2.01825 9.73175 0 7.25 0C4.76825 0 2.75 2.01825 2.75 4.5C2.75 6.98175 4.76825 9 7.25 9ZM7.25 1.5C8.9045 1.5 10.25 2.8455 10.25 4.5C10.25 6.1545 8.9045 7.5 7.25 7.5C5.5955 7.5 4.25 6.1545 4.25 4.5C4.25 2.8455 5.5955 1.5 7.25 1.5ZM17.8415 8.90925C16.991 8.05875 15.509 8.05875 14.6593 8.90925L8.75 14.8177V18H11.9323L17.8407 12.0915C18.266 11.6663 18.5 11.1015 18.5 10.5C18.5 9.8985 18.266 9.33375 17.8415 8.90925ZM16.7803 11.0302L11.3112 16.5H10.25V15.4387L15.7197 9.96975C16.0025 9.68625 16.4968 9.68625 16.7803 9.96975C16.922 10.1108 17 10.299 17 10.5C17 10.701 16.922 10.8885 16.7803 11.0302ZM9.44675 12H4.25C3.0095 12 2 13.0095 2 14.25V18H0.5V14.25C0.5 12.1823 2.18225 10.5 4.25 10.5H10.25C10.4668 10.5 10.676 10.5285 10.883 10.5638L9.44675 12Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueUser);
export default __webpack_public_path__ + "static/media/blueUser.e5c66afbffebccef1a2dfd69b5b483f4.svg";
export { ForwardRef as ReactComponent };